import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Icon from 'components/DesignSystem/Icon';
import BrandLogo from 'components/BrandLogo';
import useListHomeWarnings from 'hooks/Home/useListHomeWarnings';
import { selectTokenUserName } from 'redux/reducers/authReducer';
import getInitials from 'utils/getInitials';

import './index.scss';

export default function MobileTopBar({ onAvatarClick }: { onAvatarClick: () => void }) {
  const navigate = useNavigate();
  const userName = useSelector(selectTokenUserName);
  const { showNotification, updateLastSeen } = useListHomeWarnings();

  const onBellClick = () => {
    updateLastSeen();
    navigate('/home?tab=warnings');
  };

  return (
    <header className="mobile-top-bar">
      <Link to="/home" className="mobile-top-bar-logo" aria-label="Home">
        <BrandLogo alt="Ampere" />
      </Link>
      <div className="mobile-top-bar-actions">
        <button
          type="button"
          className="mobile-top-bar-bell"
          aria-label="Avisos"
          onClick={onBellClick}
        >
          <Icon iconType="bell" color="currentColor" />
          {showNotification && <span className="mobile-top-bar-dot" data-testid="warning-dot" />}
        </button>
        <button
          type="button"
          className="mobile-top-bar-avatar"
          aria-label="Mais"
          onClick={onAvatarClick}
        >
          {getInitials(userName)}
        </button>
      </div>
    </header>
  );
}
